import type { ScenariosTag, Tag, TagType } from '~/api/interface'

export const useCenterTags = () => {
  return useState<TagType>('centerTags', () => ({ tag_header: [], tags: [] }))
}

export const useCharacterTags = () =>
  useState<TagType>('digitalTags', () => ({ tag_header: [], tags: [] }))

export type TagInfo = Tag & { ids: string }

export const useTagMap = () => {
  return useState<Record<string, TagInfo>>('tagMap', () => ({}))
}

export const useScenariosTags = () =>
  useState<ScenariosTag[]>('scenariosTags', () => [])

// const setTags = (
//   arr?: Tag[],
//   parent?: string,
//   map?: Ref<Record<string, TagInfo>>
// ) => {
//   arr?.forEach((item) => {
//     item.ids = `${parent ? parent + ':' : ''}${item.level},${item.tag_id}`
//     map && (map.value[item.ids] = item)
//     if (item.children?.length) {
//       setTags(item.children, item.ids, map)
//     }
//   })
// }

// export async function useInitCharacterTags() {
//   const characterTags = useCharacterTags()
//   if (characterTags.value.tags.length > 0) {
//     return characterTags
//   }
//   const centerDataResult = await useAsyncData(() =>
//     getTags({
//       group: 'character',
//       is_tree: true,
//     })
//   )
//   if (centerDataResult.data.value?.data) {
//     characterTags.value = centerDataResult.data.value.data
//   }
//   return characterTags
// }

// export async function useInitTags() {
//   const centerTags = useCenterTags()
//   const digitalTags = useCharacterTags()
//   const map = useTagMap()

//   const [templateTagResult, characterTagResult] = await concurrency([
//     useAsyncData(() => getTags({ group: 'template' })),
//     useAsyncData(() => getTags({ group: 'character' })),
//   ])

//   setTags(templateTagResult.data.value?.data?.tags, undefined, map)
//   if (templateTagResult.data.value?.data) {
//     centerTags.value = templateTagResult.data.value.data
//   }

//   if (characterTagResult.data.value?.data) {
//     digitalTags.value = characterTagResult.data.value?.data
//   }
// }
